import {RestrictedRouteModuleConfiguration} from "../router/model/UserPermission";
import {
    CustomerServiceModuleName,
    DirectMailerLogsModuleName,
    UserServiceModuleName
} from "../utils/names/optionalModuleNames";
import {DirectMailerLogsControllerName} from "../utils/names/controllerNames";
import {NavigationAccessRoles, NavigationItem} from "../main/model/navigationItem";
import {UserGranredAuthorityName} from "../router/const/AllPermitions";
import {AngularJsMaterialModuleName} from "../utils/names/requiredModulesNames";
import {getTabName} from "modules/utils/TabNameUtils";

export const DirectMailerLogsModuleConfiguration = new RestrictedRouteModuleConfiguration(
    DirectMailerLogsModuleName,
    [
        DirectMailerLogsModuleName,
        AngularJsMaterialModuleName,
        CustomerServiceModuleName,
        UserServiceModuleName
    ],
    [
        ["/logging/direct_mailer", {
            template: require("./route/logging.html"),
            controller: DirectMailerLogsControllerName
        }]
    ],
    [
        new NavigationItem({
            title: "Mail Logging",
            href: "#!logging/direct_mailer",
            accessRole: [NavigationAccessRoles.ROLE_USER],
            activeFunction: routeName => routeName.indexOf("logging") !== -1 && routeName.indexOf("direct_mailer") !== -1
        })
    ],
    [DirectMailerLogsModuleName],
    [UserGranredAuthorityName.MAIL_LOGGING],
    getTabName() + '| Logging'
);

export default DirectMailerLogsModuleConfiguration;